
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { TFilterProduct, TFilterSelect, TFilterTreeSelect } from '@/common/components/redesigned/Filter/types/filter';
  import { MenuModes } from '@/common/components/redesigned/TreeMultiselect/types';
  import { TProductItem } from '@/common/components/redesigned/TreeSelectionProducts/types';
  import { TSelectOption } from '@/common/types/select';

  import { INDICATOR_TYPE_FILTER_OPTIONS, SELECT_TYPE_FILTER_OPTIONS } from '../../constants/options';
  import { COUNTRIES_LEVEL_EVENTS_LABELS } from '../../constants/tree';
  import { VED_COMMON_ACTIONS_NAME, VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TForeignTradeByRegionsFilter } from '../../types/foreign-trade-by-regions';
  import { yearMonthPeriodTreeFilterConfig } from '../../utils/filter';
  import FilterDetailsVed from '../common/FilterDetailsVed.vue';
  import FilterFactoryVed from '../common/FilterFactoryVed.vue';

  export default defineComponent({
    name: 'ForeignTradeByRegionsFilter',
    components: {
      FilterDetailsVed,
      FilterFactoryVed,
    },
    emits: {
      searchFilter: (filter: Partial<TForeignTradeByRegionsFilter>) => filter,
      updateFilter: (filter: Partial<TForeignTradeByRegionsFilter>) => filter,
      updateProductText: (productText: string) => productText,
    },
    props: {
      defaultFilter: {
        type: Object as PropType<TForeignTradeByRegionsFilter>,
        required: true,
      },
      readonlyPermissionCode: {
        type: Number,
      },
    },
    data(): {
      productText: string;
    } {
      return {
        productText: '',
      };
    },
    created() {
      this.searchCountriesTree();
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
      }),
      getFiltersConfig(): [
        TFilterTreeSelect,
        TFilterTreeSelect,
        TFilterProduct,
        TFilterSelect<TSelectOption>,
        TFilterSelect<TSelectOption>,
      ] {
        return [
          yearMonthPeriodTreeFilterConfig,
          {
            type: 'tree-select',
            label: 'Страна-партнер',
            options: this.getCountriesTree,
            vModel: 'countries',
            required: true,
            isSingleMode: true,
            levelEventsLabels: COUNTRIES_LEVEL_EVENTS_LABELS,
            menuMode: MenuModes.COMBINED_MODAL,
          },
          {
            type: 'product',
            vModel: 'product',
            required: true,
            multiple: false,
            valueUpdated: (value: TProductItem[]) => {
              const isUpdateProductText = !this.productText;

              this.productText = value.map((item) => item.name).join(', ');

              if (!isUpdateProductText) return;

              this.updateProductText();
            },
          },
          {
            type: 'select',
            label: 'Тип выборки',
            options: SELECT_TYPE_FILTER_OPTIONS,
            vModel: 'selectTypeId',
            valueProp: 'value',
            labelProp: 'label',
            required: true,
          },
          {
            type: 'select',
            label: 'Показатели',
            options: INDICATOR_TYPE_FILTER_OPTIONS,
            vModel: 'indicatorTypeId',
            valueProp: 'value',
            labelProp: 'label',
            required: true,
          },
        ];
      },
    },
    methods: {
      ...mapActions({
        searchCountriesTree: VED_COMMON_ACTIONS_NAME.searchCountriesTree,
      }),
      searchFilter(filter: Partial<TForeignTradeByRegionsFilter>) {
        this.$emit('searchFilter', filter);
        this.updateProductText();
      },
      updateFilter(filter: Partial<TForeignTradeByRegionsFilter>) {
        this.$emit('updateFilter', filter);
      },
      updateProductText() {
        this.$emit('updateProductText', this.productText);
      },
    },
  });
